import { TransactionParticipant, TransactionRole } from '@endpoint/platform-api-connector/dist/graphql-types';

export const findParticipantNameByRole = (participants: TransactionParticipant[], role: TransactionRole): string => {
  const participant = participants.find((p) => p.roles[0] === role);

  return participant ? `${participant.user?.firstName} ${participant.user?.lastName}` : '';
};
